import React, { Component } from 'react';

class LocationIcon extends Component {
  // eslint-disable-next-line class-methods-use-this
  render() {

    return (
        <img src="/images/location-pin.svg" height="30vw" alt="Location Icon" />
    );
  }
}

export default LocationIcon;
